module.exports = __webpack_public_path__ + "img/icon6.48845728.png";